    <template>
        <div class="ele-body">
            <el-card shadow="never">
                <!-- 搜索表单 -->
                <el-form v-if="search_show" :model="table.where" label-width="auto" :inline="true"
                         @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
                    <el-row :gutter="15">

                                                
                                                                                                                                                                    
                                                            <el-form-item label="素材别名:">
                                    <el-input v-model="table.where.skin_alias" placeholder="请输入素材别名"  clearable/>
                                </el-form-item>
                                                                                                        
                                                            <el-form-item label="素材名称:">
                                    <el-input v-model="table.where.skin_name" placeholder="请输入素材名称"  clearable/>
                                </el-form-item>
                                                                                                        
                                                                                                        
                                                                                                        
                                                            <el-form-item label=" 建议尺寸:">
                                    <el-input v-model="table.where.skin_size" placeholder="请输入 建议尺寸"  clearable/>
                                </el-form-item>
                                                                                                        
                                                                                                                                                                    
                                                            <el-form-item label="默认值，2为默认:">
                                    <el-input-number v-model="table.where.skin_status" placeholder="请输入默认值，2为默认" :controls="false" controls-position="right" class="ele-fluid ele-text-left" clearable/>
                                </el-form-item>
                                                                                                        
                                                            <el-form-item label="活动素材排序:">
                                    <el-input-number v-model="table.where.skin_pos" placeholder="请输入活动素材排序" :controls="false" controls-position="right" class="ele-fluid ele-text-left" clearable/>
                                </el-form-item>
                                                                                                        
                                                            <el-form-item label="创建时间:" >
                                    <el-date-picker v-model="table.where.create_time" type="datetimerange" start-placeholder="开始日期"
                                                    end-placeholder="结束日期" value-format="yyyy-MM-dd hh:mm:ss">
                                    </el-date-picker>
                                </el-form-item>
                                                                                                        <el-form-item>
                            <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search"
                                       class="ele-btn-icon">查询
                            </el-button>
                            <el-button @click="(table.where={})&&$refs.table.reload()">重置</el-button>
                            <el-button type="success" @click="exportExcel();" icon="el-icon-download" class="ele-btn-icon"
                                       v-if="permission.includes('sys:activityturntableskin:export')">导出数据
                            </el-button>
                        </el-form-item>
                    </el-row>
                </el-form>
                <!-- 操作按钮 -->

                <div class="ele-table-tool ele-table-tool-default">
                    <el-button @click="(table.where={})&&$refs.table.reload()" type="info" icon="el-icon-refresh"
                               class="ele-btn-icon" size="small" >刷新
                    </el-button>
                    <el-button @click="showEdit=true" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small" v-if="permission.includes('sys:activityturntableskin:add')">添加
                    </el-button>
                    <el-button @click="remove()" type="danger" icon="el-icon-delete" class="ele-btn-icon" size="small" v-if="permission.includes('sys:activityturntableskin:dall')">批量删除
                    </el-button>
                    <el-button :type="search_show?'warning':'info'" size="small" icon="el-icon-search"
                               @click="search_show=!search_show">搜索</el-button>
                </div>

                <!-- 数据表格 -->
                <ele-data-table ref="table" :config="table" :choose.sync="choose" height="calc(100vh - 315px)" highlight-current-row>
                    <template slot-scope="{index}">
                        <el-table-column type="selection" width="45" align="center" fixed="left"/>
                        <el-table-column type="index" :index="index" label="编号" width="60" align="center" fixed="left" show-overflow-tooltip/>
                                                                                    
                                                                                                                
                                    <el-table-column prop="skin_alias" label="素材别名" sortable="custom" show-overflow-tooltip min-width="120"/>
                                                                                                                                                    
                                    <el-table-column prop="skin_name" label="素材名称" sortable="custom" show-overflow-tooltip min-width="120"/>
                                                                                                                                                    <el-table-column prop="skin_img" label="素材图片" show-overflow-tooltip min-width="250" >
                                    <template slot-scope="{row}">
                                        <el-image
                                                style="width: 50px; height: 50px"
                                                :src="row.skin_img"
                                                :preview-src-list="[row.skin_img]">
                                        </el-image>
                                    </template>
                                </el-table-column>
                                                                                                                                                                    
                                    <el-table-column prop="skin_size" label=" 建议尺寸" sortable="custom" show-overflow-tooltip min-width="120"/>
                                                                                                                                                    
                                                                                                                
                                    <el-table-column prop="skin_status" label="默认值，2为默认" sortable="custom" show-overflow-tooltip min-width="120"/>
                                                                                                                                                    
                                    <el-table-column prop="skin_pos" label="活动素材排序" sortable="custom" show-overflow-tooltip min-width="120"/>
                                                                                                                                            
                        <el-table-column label="创建时间" sortable="custom" show-overflow-tooltip min-width="160">
                            <template slot-scope="{row}">{{ row.create_time*1000 | toDateString }}</template>
                        </el-table-column>
                        <el-table-column label="更新时间" sortable="custom" show-overflow-tooltip min-width="160">
                            <template slot-scope="{row}">{{ row.update_time*1000 | toDateString }}</template>
                        </el-table-column>
                        <el-table-column label="操作" width="130px" align="center" :resizable="false"  fixed="right">
                            <template slot-scope="{row}">
                                <el-link @click="edit(row)" icon="el-icon-edit" type="primary" :underline="false" v-if="permission.includes('sys:activityturntableskin:edit')">修改</el-link>
                                <el-popconfirm title="确定要删除此活动素材吗？" @confirm="remove(row)" class="ele-action">
                                    <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false" v-if="permission.includes('sys:activityturntableskin:delete')">删除</el-link>
                                </el-popconfirm>
                            </template>
                        </el-table-column>
                    </template>
                </ele-data-table>
            </el-card>
            <!-- 编辑弹窗 -->
            <el-dialog :title="editForm.id?'修改活动素材':'添加活动素材'" :visible.sync="showEdit"  width="800px" :destroy-on-close="true" :lock-scroll="false" @close="closeDialog" :close-on-click-modal="false">
                <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="auto" class="demo-ruleForm">
                                                                        
                                
                                                                                                                                            
                                                                <el-form-item label="素材别名:" prop="skin_alias">
                                    <el-input v-model="editForm.skin_alias" placeholder="请输入素材别名" clearable />
                                </el-form-item>
                                                                                                            
                                                                <el-form-item label="素材名称:" prop="skin_name">
                                    <el-input v-model="editForm.skin_name" placeholder="请输入素材名称" clearable />
                                </el-form-item>
                                                                                                            
                                
                                <el-form-item label="素材图片:" prop="skin_img">
                                    <ele-uploadimage :limit="1" v-model="editForm.skin_img"></ele-uploadimage>

                                </el-form-item>
                                                                                                            
                                
                                <el-form-item label="css样式:" prop="skin_css">
                                    <el-input type="textarea" v-model="editForm.skin_css" placeholder="请输入css样式" clearable />
                                </el-form-item>
                                                                                                            
                                                                <el-form-item label=" 建议尺寸:" prop="skin_size">
                                    <el-input v-model="editForm.skin_size" placeholder="请输入 建议尺寸" clearable />
                                </el-form-item>
                                                                                                            
                                
                                                                                                                                            
                                                                <el-form-item label="默认值，2为默认:" prop="skin_status">
                                    <el-input-number v-model="editForm.skin_status" controls-position="right" :controls="false" :precision="0" class="ele-fluid ele-text-left" placeholder="请输入默认值，2为默认" clearable />
                                </el-form-item>
                                                                                                            
                                                                <el-form-item label="活动素材排序:" prop="skin_pos">
                                    <el-input-number v-model="editForm.skin_pos" controls-position="right" :controls="false" :precision="0" class="ele-fluid ele-text-left" placeholder="请输入活动素材排序" clearable />
                                </el-form-item>
                                                                                                            
                                                                                                        
                </el-form>
                <div slot="footer">
                    <el-button @click="closeDialog">取消</el-button>
                    <el-button type="primary" @click="save">保存</el-button>
                </div>
            </el-dialog>
        </div>
    </template>

    <script>
        import { mapGetters } from "vuex";

                import EleUploadimage from '@/components/EleUploadimage'
                                        
        export default {
            name: "SysActivityTurntableSkin",
            components: {
                                EleUploadimage,
                                                                            },
            data() {
                return {
                                        table: {
                        url: '/activity/ActivityTurntableSkin/index',
                        where: {"skin_img":[]}                    },  // 表格配置
                    choose: [],  // 表格选中数据
                    showEdit: false,  // 是否显示表单弹窗
                    editForm: {"skin_img":[]},  // 表单数据
                    editFormTemp:{"skin_img":[]},
                    admin_list:[],
                    user_list:[],
                    search_show:false,
                                    editRules: {  // 表单验证规则
                                                            
                    skin_class_id: [
                        {required: true, message: '请选择', trigger: 'blur'}
                    ],
                    
                                        
                    skin_alias: [
                        {required: true, message: '请输入素材别名', trigger: 'blur'}],
                    
                                        
                    skin_name: [
                        {required: true, message: '请输入素材名称', trigger: 'blur'}],
                    
                                        
                    skin_img: [
                        {required: true, message: '请上传素材图片', trigger: 'blur'}
                    ],
                    
                                        
                    skin_css: [
                        {required: true, message: '请输入css样式', trigger: 'blur'}],
                    
                                        
                    skin_size: [
                        {required: true, message: '请输入 建议尺寸', trigger: 'blur'}],
                    
                                        
                    skin_type_id: [
                        {required: true, message: '请选择类型ID', trigger: 'blur'}
                    ],
                    
                                        
                    skin_status: [
                        {required: true, message: '请输入默认值，2为默认', trigger: 'blur'}],
                    
                                        
                    skin_pos: [
                        {required: true, message: '请输入活动素材排序', trigger: 'blur'}],
                    
                                        
                    create_time: [
                        {required: true, message: '请选择创建时间', trigger: 'blur'}
                    ],
                    
                                        
                },
            }
            },
            computed: {
                ...mapGetters(["permission"]),
                            },
            mounted() {

                                                            },
            methods: {

                /**
                 * 关闭
                 */
                closeDialog(){
                    this.showEdit = false;
                    this.editForm = JSON.parse(JSON.stringify(this.editFormTemp));
                },
                /**
                 * 显示编辑
                 */
                edit(row) {
                    this.$http.get('/activity/ActivityTurntableSkin/info?id=' + row.id).then(res => {
                        if (res.data.code === 0) {
                            this.showEdit = true;
                            setTimeout(() => {
                                this.editForm = res.data.data;
                            }, 100);
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        this.$message.error(e.message);
                    });
                },
                /**
                 * 保存编辑
                 */
                save() {
                    this.$refs['editForm'].validate((valid) => {
                        if (valid) {
                            const loading = this.$loading({lock: true});
                            this.$http.post('/activity/ActivityTurntableSkin/edit', this.editForm).then(res => {
                                loading.close();
                                if (res.data.code === 0) {
                                    this.showEdit = false;
                                    this.$message({type: 'success', message: res.data.msg});
                                    this.$refs.table.reload();
                                } else {
                                    this.$message.error(res.data.msg);
                                }
                            }).catch(e => {
                                loading.close();
                                this.$message.error(e.message);
                            });
                        } else {
                            return false;
                        }
                    });
                },
                /**
                 * 刪除(批量刪除)
                 */
                remove(row) {
                    console.log(row)
                    if (!row) {  // 批量删除
                        if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
                        let ids = this.choose.map(d => d.id);
                        this.$confirm('确定要删除选中的活动素材吗?', '提示', {type: 'warning'}).then(() => {
                            const loading = this.$loading({lock: true});
                            this.$http.post('/activity/ActivityTurntableSkin/delete', {id: ids}).then(res => {
                                loading.close();
                                if (res.data.code === 0) {
                                    this.$message({type: 'success', message: res.data.msg});
                                    this.$refs.table.reload();
                                } else {
                                    this.$message.error(res.data.msg);
                                }
                            }).catch(e => {
                                loading.close();
                                this.$message.error(e.message);
                            });
                        }).catch(() => 0);
                    } else {  // 单个删除
                        const loading = this.$loading({lock: true});
                        this.$http.post('/activity/ActivityTurntableSkin/delete', {id:row.id}).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.$message({type: 'success', message: res.data.msg});
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    }
                },

                                                /* 导出数据Excel */
                exportExcel() {
                    let ids  = this.choose.map(d => d.id)
                    if(ids.length == 0){
                        this.$message.error('请选择要导出的数据');
                        return false;
                    }
                    this.$http
                        .post("/activity/ActivityTurntableSkin/exportExcel", {id:ids})
                        .then((res) => {
                            let data = res.data;
                            if (data.code == 0) {
                                // 下载文件
                                window.location.href = data.data;
                                this.$message({
                                    type: "success",
                                    message: "导出成功",
                                });
                            } else {
                                this.$message.error("导出失败");
                            }
                        })
                },
                
            
                }
        }
    </script>

    <style scoped>
        .ele-block >>> .el-upload, .ele-block >>> .el-upload-dragger {
            width: 100%;
        }
    </style>
